
import { Outlet } from "react-router-dom";

export const InventoryOutlet = () => {
  return <Outlet />;
};
